const conf = {
  production: {
    mode: 'production',
    env: 'production',
    domain: 'https://secure.vormats.com',
    cms: 'https://cms.vormats.com/api',
    cmsUrl: 'https://cms.vormats.com',
    vormatsApi: 'https://prod.api.vormats.com',
    advancedVideoEditorUrl: 'https://secure.vormats.com/advanced-video-editor',
    clientId: 'vormats_api',
    clientSecret: 'N{jIUAylEGds%]xMWZk9',
    staticResourcesBucket: 'prod-static-video-resources',
    chromeWebStoreUrl: 'https://chrome.google.com/webstore/detail/vormats/pppgcnfdhkckmhecigcoiklpnkmjpoko',
    edgeWebStoreUrl: 'https://microsoftedge.microsoft.com/addons/detail/vormats-screen-recorder/bdbaniffigellkkjlgkoedbiilhecljk',
    extensionId: 'pppgcnfdhkckmhecigcoiklpnkmjpoko',
    crispId: '4f28efcc-9a8f-432e-810b-9bb517a30ced',
    crispSecretToken: '674709d612b164a3700c1843da3620a9',
    gtmTrackingId: 'GTM-NJTG4SVS',
    appcuesId: '146191',
    renderEngineDeployTimestamp: 1649419861000,
    sentryDsn: 'https://1b008c2a83bc83b500f751bfe40405ff@o4508454496960512.ingest.de.sentry.io/4508454504366160',
    firebaseConfig: {
      apiKey: 'AIzaSyABxuRDym44t4-XPtoaq8eHH6WoSpHCFeY',
      authDomain: 'vormats-20.firebaseapp.com',
      databaseURL: 'https://vormats-20.firebaseio.com',
      projectId: 'vormats-20',
      storageBucket: 'vormats-20.appspot.com',
      messagingSenderId: '548152441469',
      appId: '1:548152441469:web:4f17c20a335c15bd1dcf14',
      measurementId: 'G-ZHBX96DQQH',
    },
    useCaseTemplatesJsonUrl: "https://prod-static-video-resources.s3.eu-west-1.amazonaws.com/manual-uploads/use-case-templates-prompts.json"
  },
  staging: {
    mode: 'production',
    env: 'dev',
    domain: 'https://app-dev.vormats.com',
    cms: 'https://test.vormats.com/api',
    cmsUrl: 'https://test.vormats.com',
    vormatsApi: 'https://dev.api.vormats.com',
    advancedVideoEditorUrl: 'https://app-dev.vormats.com/advanced-video-editor',
    clientId: 'vormats_api',
    clientSecret: 'v4x)\\!TEatc*<P^B{4U$',
    staticResourcesBucket: 'dev-static-video-resources',
    chromeWebStoreUrl: 'https://chrome.google.com/webstore/detail/vormats/pppgcnfdhkckmhecigcoiklpnkmjpoko',
    edgeWebStoreUrl: 'https://microsoftedge.microsoft.com/addons/detail/vormats-screen-recorder/bdbaniffigellkkjlgkoedbiilhecljk',
    extensionId: 'fkkpceebpmlipopmbhkehealhbhdoaep',
    crispId: '4f28efcc-9a8f-432e-810b-9bb517a30ced',
    crispSecretToken: '674709d612b164a3700c1843da3620a9',
    poeditorApiToken: '21d93b9a29aa259bf025ed9dd98169f5',
    poeditorId: '526525',
    appcuesId: '146191',
    renderEngineDeployTimestamp: 1649156444000,
    sentryDsn: 'https://7f89e59d18f144b8ecb18e69b747ef59@o4508454496960512.ingest.de.sentry.io/4508454502662224',
    firebaseConfig: {
      apiKey: 'AIzaSyABxuRDym44t4-XPtoaq8eHH6WoSpHCFeY',
      authDomain: 'vormats-20.firebaseapp.com',
      databaseURL: 'https://vormats-20.firebaseio.com',
      projectId: 'vormats-20',
      storageBucket: 'vormats-20.appspot.com',
      messagingSenderId: '548152441469',
      appId: '1:548152441469:web:6be5c7177eb212b01dcf14',
      measurementId: 'G-EY8BL215N8',
    },
    typebotId: "web-app-dev-latest",
    typebotHostUrl: "https://assistant.vormats.com",
    typebotAssistantDbJsonUrl: "https://dev-static-video-resources.s3.eu-west-1.amazonaws.com/manual-uploads/assistant-templates-dev.json"
  },
  development: {
    mode: 'development',
    env: 'local',
    domain: 'https://app-dev.vormats.com',
    cms: 'https://test.vormats.com/api',
    cmsUrl: 'https://test.vormats.com',
    vormatsApi: 'https://dev.api.vormats.com',
    advancedVideoEditorUrl: 'http://localhost:3004/advanced-video-editor',
    clientId: 'vormats_api',
    clientSecret: 'v4x)\\!TEatc*<P^B{4U$',
    staticResourcesBucket: 'dev-static-video-resources',
    chromeWebStoreUrl: 'https://chrome.google.com/webstore/detail/vormats/pppgcnfdhkckmhecigcoiklpnkmjpoko',
    edgeWebStoreUrl: 'https://microsoftedge.microsoft.com/addons/detail/vormats-screen-recorder/bdbaniffigellkkjlgkoedbiilhecljk',
    extensionId: 'fkkpceebpmlipopmbhkehealhbhdoaep',
    crispId: '4f28efcc-9a8f-432e-810b-9bb517a30ced',
    crispSecretToken: '674709d612b164a3700c1843da3620a9',
    poeditorApiToken: '21d93b9a29aa259bf025ed9dd98169f5',
    poeditorId: '526525',
    appcuesId: '146191',
    renderEngineDeployTimestamp: 1649156444000,
    firebaseConfig: {
      apiKey: 'AIzaSyABxuRDym44t4-XPtoaq8eHH6WoSpHCFeY',
      authDomain: 'vormats-20.firebaseapp.com',
      databaseURL: 'https://vormats-20.firebaseio.com',
      projectId: 'vormats-20',
      storageBucket: 'vormats-20.appspot.com',
      messagingSenderId: '548152441469',
      appId: '1:548152441469:web:6be5c7177eb212b01dcf14',
      measurementId: 'G-EY8BL215N8',
    },
    typebotId: "web-app-dev-latest",
    typebotHostUrl: "https://assistant.vormats.com",
    typebotAssistantDbJsonUrl: "https://dev-static-video-resources.s3.eu-west-1.amazonaws.com/manual-uploads/assistant-templates-dev.json",
  },
  local: {
    mode: 'development',
    env: 'local',
    domain: 'http://localhost:3000',
    server: 'http://[::1]:3001',
    cms: 'https://test.vormats.com/api',
    cmsUrl: 'https://test.vormats.com',
    vormatsApi: 'https://dev.api.vormats.com',
    advancedVideoEditorUrl: 'http://localhost:3004/advanced-video-editor',
    clientId: 'vormats_api',
    clientSecret: 'v4x)\\!TEatc*<P^B{4U$',
    staticResourcesBucket: 'dev-static-video-resources',
    chromeWebStoreUrl: 'https://chrome.google.com/webstore/detail/vormats/pppgcnfdhkckmhecigcoiklpnkmjpoko',
    edgeWebStoreUrl: 'https://microsoftedge.microsoft.com/addons/detail/vormats-screen-recorder/bdbaniffigellkkjlgkoedbiilhecljk',
    extensionId: 'fkkpceebpmlipopmbhkehealhbhdoaep',
    crispId: '4f28efcc-9a8f-432e-810b-9bb517a30ced',
    crispSecretToken: '674709d612b164a3700c1843da3620a9',
    poeditorApiToken: '21d93b9a29aa259bf025ed9dd98169f5',
    poeditorId: '526525',
    appcuesId: '146191',
    renderEngineDeployTimestamp: 1649156444000,
    firebaseConfig: {
      apiKey: 'AIzaSyABxuRDym44t4-XPtoaq8eHH6WoSpHCFeY',
      authDomain: 'vormats-20.firebaseapp.com',
      databaseURL: 'https://vormats-20.firebaseio.com',
      projectId: 'vormats-20',
      storageBucket: 'vormats-20.appspot.com',
      messagingSenderId: '548152441469',
      appId: '1:548152441469:web:6be5c7177eb212b01dcf14',
      measurementId: 'G-EY8BL215N8',
    },
    typebotId: "web-app-dev-latest",
    typebotHostUrl: "https://assistant.vormats.com",
    typebotAssistantDbJsonUrl: "https://dev-static-video-resources.s3.eu-west-1.amazonaws.com/manual-uploads/assistant-templates-dev.json",
  },
  general: {
    minPasswordLength: 10,
  },
};

module.exports = conf;

